import $ from 'jquery'
window.jQuery=$;

$(".actbtn").click(function(e) {
  e.preventDefault();
  var target=$("#"+$(this).attr("href").replace(/^\/?#/, ""));
  var targetTop=target.offset().top;
  $("html,body").animate({scrollTop: targetTop-40});
});

// $(".hi-items").each(function() {
//   var container=$(this);
//   var els=container.find(">li");
//   var prev=container.next(".hi-progress").find(">.prev");
//   var next=container.next(".hi-progress").find(">.next");
//   var valEl=container.next(".hi-progress").find(">.val");
//   var current=0;
//   var oldPos=0;
//
//   var updateCurrent=function() {
//     container.animate({scrollLeft: els.eq(0).innerWidth()*current});
//   }
//   container.on("scroll", function(e) {
//     var pos=Math.round(container.scrollLeft()/els.eq(0).innerWidth());
//     if (pos!=oldPos) {
//       valEl.html((pos+1)+" / "+els.length);
//       current=pos;
//     }
//     oldPos=pos;
//   });
//
//   prev.click(function(e) {
//     current=(current+els.length-1)%els.length;
//     updateCurrent();
//     e.preventDefault();
//   });
//   next.click(function(e) {
//     current=(current+1)%els.length;
//     updateCurrent();
//     e.preventDefault();
//   });
//
// });
//
//
// $(".pr-content").each(function() {
//   var container=$(this);
//   var els=container.find(">li");
//   var lis=container.next(".pr-list").find(">ul>li");
//   var links=container.next(".pr-list").find(">ul>li>a");
//
//   links.click(function(e) {
//     e.preventDefault();
//     var index=links.index(this);
//     container.animate({scrollTop: els.eq(0).innerHeight()*index});
//     lis.removeClass("active").eq(index).addClass("active");
//   });
//
// });
//
// $(".hm-list").each(function() {
//   var $this=$(this);
//   var container=$this.next(".hm-content").find(">ul");
//   var els=$this.next(".hm-content").find(">ul>li");
//   var lis=$this.find(">ul>li");
//   var links=$this.find(">ul>li>a");
//
//   links.click(function(e) {
//     e.preventDefault();
//     var index=links.index(this);
//     container.animate({scrollTop: els.eq(0).innerHeight()*index});
//     lis.removeClass("active").eq(index).addClass("active");
//   });
//
// });
//
//
// $(".mob-handle").click(function(e) {
//   e.preventDefault();
//   $("header .navc").toggleClass("open");
// });
//
//
// $(".media-single iframe").each(function() {
//   $(this).wrap("<div class=\"iframe-wrapper\" />");
// });


$("header .nav-toggle").click(function(e) {
  $(this).toggleClass("open");
  var nav=$("header nav");
  if ($(this).hasClass("open")) {
    nav.css("height", nav.find("ul").innerHeight());
  } else {
    nav.css("height", "0");
  }
});
